import { Box, Modal } from "@mui/material";
import React from "react";
import { IoClose } from "react-icons/io5";


interface ModalProps {
  open: boolean;
  label?: string;
  onClose?: () => void;
  onSubmit?: () => void;
  company?: any;
  setCompany?: any;
  children?: any;
}
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 800,
  width: "90%",
  maxHeight: "90vh",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  gap: 2,
  borderRadius: "10px",
  overflow: "hidden",
};
const CustomModal = ({
  open,
  onClose,
  label,
    children,
}: ModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className={""}
      sx={{
        "& .MuiModal-backdrop": {
          backdropFilter: " blur(4px) !important",
          background: "#00000099 !important",
        },
      }}
    >
      <Box sx={style} className={"bg-primary"}>
        <div className={"w-full flex justify-between items-center flex-shrink-0"}>
          <div className={"text-2xl font-bold text-primaryText"}>
            {label}
          </div>
          <IoClose onClick={onClose} size={20} className={"text-white cursor-pointer"} />
        </div>
        <div className={"flex-1 overflow-y-auto overflow-x-hidden pr-1"}>
          {children}
        </div>
      </Box>
    </Modal>
  );
};
export default CustomModal;
